import { MANTY_CYAN } from 'styles/theme';

export enum SimulationTypeEnum {
    PROJECTION = 'projection',
    BUDGET_PROPOSAL = 'budget_proposal',
}

export const SIMULATION_TYPE_COLORS = {
    color: {
        [SimulationTypeEnum.PROJECTION]: '#388866',
        [SimulationTypeEnum.BUDGET_PROPOSAL]: MANTY_CYAN,
    },
    background: {
        [SimulationTypeEnum.PROJECTION]: 'rgba(56, 136, 102, 0.15)',
        [SimulationTypeEnum.BUDGET_PROPOSAL]: 'rgba(3, 110, 187, 0.15)',
    },
} as const;

export const SIMULATION_ENDPOINT_PREFIX = 'human_resources/hr_simulation';
